import React from 'react';

const JS_Mistakes = () => {
  return (
    <div >
      <h1>JS_Mistakes</h1>
      <p>Placeholder component for: "JS Mistakes"</p>
    </div>
  );
};

export default JS_Mistakes;
